module.exports = __webpack_public_path__ + "static/ko-b938b01b5b5316b5d8c407d63d6e367b.svg";